export const INIT_STATE = {
  modal: {
    show: false,
  },
  toast: {
    show: false,
    message: '',
    type: 'success',
  },
  currentId: {
    id: 0,
  },
  categories: {
    loading: false,
    data: [],
  },
  warehouses: {
    loading: false,
    data: [],
  },
  suppliers: {
    loading: false,
    data: [],
  },
  products: {
    loading: false,
    data: [],
    singleProduct: null,
    latestProducts: [],
    topRatingProducts: [],
    topDiscountProducts: [],
    relatedProducts: [],
  },
  customers: {
    loading: false,
    data: [],
  },
  comments: {
    loading: false,
    data: [],
  },
  orders: {
    loading: false,
    data: [],
    userOrders: [],
  },
  admins: {
    loading: false,
    data: [],
  },
};
